var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('v-base-card',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v(" お知らせ "+_vm._s(_vm.actionName)+" ")]},proxy:true},{key:"content",fn:function(){return [_c('v-notification-form',{on:{"submit":_vm.submit}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }